// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
header {
    z-index: 999999 !important;
}
.selection.form-select {
    width: 250px;
    height: 45px;
    margin-bottom: 0px;
    padding: 0 15px;
    border-radius: 0;
    border: 1px solid var(--border-color) !important;
    background-color: transparent;
    color: var(--bs-black-rgb);
    box-shadow: none;
    outline: none;
    border-radius: var(--border-radius);
    cursor: pointer;
}

.selection.form-select:focus {
    border: none;
    outline: none;
    box-shadow: none;
}

.storeName {
    font-size: 16px;
    font-weight: 500;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    color: var(--card-title-color);
}

.user_profile_drop_down{
    position: absolute;
    right: 1px;
    top:25px;
    color:#8f8f8f !important
}

.selected_store_url {
    color: var(--admin-color);
    cursor: pointer;
    border-bottom: 1px solid;
}

.selected_store_url:hover {
    /* color: #00a4bb; */
}

.navbar-expand-lg.hideDropdown {
    justify-content: space-between;
}

.headerwrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
}

.brandTitle {
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 2px;
    position: fixed;
    color: #000;
}

.ec-brand span .brandTitle img {
    max-width: 27%;
}

.progressBarBlock {
    top: 0px !important;
}

.storeAdmin {
    font-size: 16px;
    font-weight: 500;
    color: #56606e;
}

.storeAdmin:hover {
    color: #00a4bb;
}

.dropdown-header p {
    margin-top: 5px;
    color: var(--text-color);
    margin-left: 5px;
}

.dropdown-header {
    display: flex;
    align-items: center;
}

.dropdown-toggle {
    display: flex;
    align-items: end;
}

.user_logo {
    width: 40px;
    height: 40px;
    background-color: var(--gray-bg-color);
    color: #9d9d9d;
    font-size: 20px;
    line-height: 50px;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.user_info {
    display: flex;
    flex-direction: column;
    align-items: initial;
    flex-wrap: wrap;
    width: 175px;
    white-space: pre-wrap;
}

.user_info .email {
    font-size: 12px;
    width: 175px;
    word-wrap: break-word;
}

.unexpacted_error {
    position: absolute;
    left: 45%;
    top: 100px;
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":";AACA;IACI,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gDAAgD;IAChD,6BAA6B;IAC7B,0BAA0B;IAE1B,gBAAgB;IAChB,aAAa;IACb,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AACd","sourcesContent":["\nheader {\n    z-index: 999999 !important;\n}\n.selection.form-select {\n    width: 250px;\n    height: 45px;\n    margin-bottom: 0px;\n    padding: 0 15px;\n    border-radius: 0;\n    border: 1px solid var(--border-color) !important;\n    background-color: transparent;\n    color: var(--bs-black-rgb);\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    outline: none;\n    border-radius: var(--border-radius);\n    cursor: pointer;\n}\n\n.selection.form-select:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n}\n\n.storeName {\n    font-size: 16px;\n    font-weight: 500;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    color: var(--card-title-color);\n}\n\n.user_profile_drop_down{\n    position: absolute;\n    right: 1px;\n    top:25px;\n    color:#8f8f8f !important\n}\n\n.selected_store_url {\n    color: var(--admin-color);\n    cursor: pointer;\n    border-bottom: 1px solid;\n}\n\n.selected_store_url:hover {\n    /* color: #00a4bb; */\n}\n\n.navbar-expand-lg.hideDropdown {\n    justify-content: space-between;\n}\n\n.headerwrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    flex-direction: row;\n}\n\n.brandTitle {\n    font-size: 18px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    position: fixed;\n    color: #000;\n}\n\n.ec-brand span .brandTitle img {\n    max-width: 27%;\n}\n\n.progressBarBlock {\n    top: 0px !important;\n}\n\n.storeAdmin {\n    font-size: 16px;\n    font-weight: 500;\n    color: #56606e;\n}\n\n.storeAdmin:hover {\n    color: #00a4bb;\n}\n\n.dropdown-header p {\n    margin-top: 5px;\n    color: var(--text-color);\n    margin-left: 5px;\n}\n\n.dropdown-header {\n    display: flex;\n    align-items: center;\n}\n\n.dropdown-toggle {\n    display: flex;\n    align-items: end;\n}\n\n.user_logo {\n    width: 40px;\n    height: 40px;\n    background-color: var(--gray-bg-color);\n    color: #9d9d9d;\n    font-size: 20px;\n    line-height: 50px;\n    border-radius: 25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.user_info {\n    display: flex;\n    flex-direction: column;\n    align-items: initial;\n    flex-wrap: wrap;\n    width: 175px;\n    white-space: pre-wrap;\n}\n\n.user_info .email {\n    font-size: 12px;\n    width: 175px;\n    word-wrap: break-word;\n}\n\n.unexpacted_error {\n    position: absolute;\n    left: 45%;\n    top: 100px;\n    color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
